export const randomizeList = <T>(list: T[]): T[] => {
  return list ? list.sort(() => 0.5 - Math.random()) : [];
};

export default randomizeList;
